import React from 'react';
import { View, TouchableOpacity, Text } from "react-native";
import { useRouter } from 'expo-router';
import { usePersistBoundStore } from '@/services/zustand/Store';

export default function EditionPicker() {
    const router = useRouter();
    const updateSessionFavouriteEdition = usePersistBoundStore.getState().updateFavouriteEdition;

    const handleLinkPress = async (edition: string) => {
        updateSessionFavouriteEdition(edition);
        router.back();
    };

    return (
        <View>
            <TouchableOpacity onPress={() => handleLinkPress('DLZ')}><Text style={{ color: '#666', fontSize: 26, margin: 10 }}>Dithmarscher Landeszeitung</Text></TouchableOpacity>
            <TouchableOpacity onPress={() => handleLinkPress('DK')}><Text style={{ color: '#666', fontSize: 26, margin: 10 }}>Dithmarscher Kurier</Text></TouchableOpacity>
            <TouchableOpacity onPress={() => handleLinkPress('MZ')}><Text style={{ color: '#666', fontSize: 26, margin: 10 }}>Marner Zeitung</Text></TouchableOpacity>
            <TouchableOpacity onPress={() => handleLinkPress('BZ')}><Text style={{ color: '#666', fontSize: 26, margin: 10 }}>Brunsbüttler Zeitung</Text></TouchableOpacity>
            <TouchableOpacity onPress={() => handleLinkPress('SONNTAG')}><Text style={{ color: '#666', fontSize: 26, margin: 10 }}>Sonntagsanzeiger</Text></TouchableOpacity>
        </View>
    );
}

/*
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F5FCFF',
    },
    dayContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    customText: {
        fontSize: 12,
        color: 'gray',
    },
    text: {
        textAlign: 'center',
        padding: 10,
        backgroundColor: 'lightgrey',
        fontSize: 16
    },
    calendar: {
        marginBottom: 10
    },
});
*/
